import React from "react";

import "./TroubleReportStyle.css";

const TroubleReport = ({ headline, content, creationDate }) => {
  return (
    <div className="TroubleReport">
      <p className="date-of-creation">Erstellt am: {creationDate}</p>
      <h3>{headline}</h3>
      <p>{content}</p>
    </div>
  );
};

export default TroubleReport;
